// extracted by mini-css-extract-plugin
export default {"button":"form_button__QFkXz","wrapper":"form_wrapper__IZtc9","a":"form_a__FDzQ-","reset":"form_reset__Z0V6E"};